var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":".2","d":"m2 2 24 24m0-24L2 26","stroke":"#000","strokeWidth":"4"}));
}

CloseInline.defaultProps = {"viewBox":"0 0 28 28","width":"28","height":"28","fill":"none"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
